import { FormControl } from "@angular/forms";

export interface PatientForm {
  firstname: FormControl<string>; //required
  lastname: FormControl<string>; //required
  tutor_name: FormControl<string>;
  email: FormControl<string | null>;
  id_number: FormControl<number | null>; //required
  phone_number: FormControl<string | null>; //required
  address: FormControl<string>;
  health_insurance_id: FormControl<number | null>;
  prepaid_id: FormControl<number | null | string>;
  id_card: FormControl<number | null>;
  pathology_id: FormControl<number | null>; //required
  gender: FormControl<string>; //required
  birthday: FormControl<Date | null>;
  medic_id: FormControl<number | null>; //required
}
